import { animatePulse } from "@/src/utils/animation.utils";
import { useEffect, useRef } from "react";
import { Animated, View } from "react-native";

const LeaderboardSkeletonRow = () => {
  const opacity = useRef(new Animated.Value(0.3)).current;

  useEffect(() => {
    animatePulse(opacity);
  }, []);

  return (
    <Animated.View
      style={{ opacity }}
      className="flex-row items-center px-4 py-3 border-b border-ash-3"
    >
      {/* Rank */}
      <View className="w-10 items-center">
        <View className="h-6 w-6 rounded-full bg-ash-3" />
      </View>

      {/* Avatar + name */}
      <View className="flex-1 flex-row items-center gap-2">
        <View className="h-8 w-8 rounded-full bg-ash-3" />
        <View className="h-3 w-1/2 rounded-md bg-ash-3" />
      </View>

      {/* Points */}
      <View className="w-24 items-center">
        <View className="h-3 w-12 rounded-md bg-ash-3" />
      </View>

      {/* Achievements */}
      <View className="w-12 items-center">
        <View className="h-3 w-6 rounded-md bg-ash-3" />
      </View>
    </Animated.View>
  );
};

const LeaderboardSkeleton = ({ count = 7 }: { count?: number }) => (
  <View className="rounded-2xl overflow-hidden bg-chalk md:border md:border-ash-3">
    {Array.from({ length: count }).map((_, index) => (
      <LeaderboardSkeletonRow key={index} />
    ))}
  </View>
);

export default LeaderboardSkeleton;
